module.exports = __webpack_public_path__ + "assets/webLinks.e652fcc8.svg";